module.exports = {"available":"Frei","booked":"Gebucht","occupied":"Besetzt","booked-occupied":"Gebucht / Besetzt","until":"bis","used":"verwendet","all-day":"den ganzen Tag","page_over_total":"Seite {page} von {total}","room-name":"Raum","current-booking":"Aktuelle Buchung","next-booking":"Nächste Buchung","unknown":"unbekannt","floors":"Stockwerke","today":"heute","no_bookings":"Keine Buchung für heute geplant","no_information":"Keine Informationen.","description":"Beschreibung","capacity":"Kapazität","allocated":"Zugewiesen","booked-occupied-allocated":"Gebucht / Besetzt / Zugewiesen"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/de.json
// module id = 0BFZ
// module chunks = 2